// System area: dashboard (+ My Day), analytics, audit log, users, integrations.
export const system = {
  dashboard: {
    welcome: "Welcome back, {{name}}!",
    overview: "Here's an overview of your account.",
    stats: {
      newInquiries: "New Inquiries",
      todayCount: "+{{count}} today",
      activeTrips: "Active Trips",
      departingThisMonth: "{{count}} departing this month",
      customers: "Customers",
      newThisMonth: "+{{count}} this month",
      revenueThisMonth: "Revenue This Month",
      vsLastMonth: "{{change}}% vs last month",
    },
    recentInquiries: "Recent Inquiries",
    viewAll: "View all",
    noRecentInquiries: "No recent inquiries",
    upcomingDepartures: "Upcoming Departures",
    noUpcomingDepartures: "No upcoming departures",
    participants: "{{participants}} participants",
    reminders: "Reminders",
    relativeTime: {
      justNow: "just now",
      minutes: "{{mins}} min",
      hours: "{{hrs}} hr",
      days_one: "{{count}} day",
      days_few: "{{count}} days",
      days_other: "{{count}} days",
    },
  },
  myDay: {
    suggestedBy: "Suggested by MAKEJ!",
    handToAgent: "Hand this to MAKEJ! to draft",
    allCaughtUp: "No open tasks — you're all caught up 🎉",
    overdue: "Overdue",
    today: "Today",
    thisWeek: "This week",
    markDone: "Mark done",
  },
  analytics: {
    subtitle: "Performance overview and key metrics",
    loadFailed: "Failed to load analytics",
    tryAgain: "Please try again",
    noData: "No data",
    mom: "MoM",
    yoy: "YoY",
    periods: {
      month: "This month",
      quarter: "This quarter",
      year: "This year",
    },
    tabs: {
      revenue: "Revenue",
      orders: "Orders",
      trips: "Trips",
      customers: "Customers",
      guides: "Guides",
      marketing: "Marketing",
      traffic: "Traffic",
      ads: "Ads & ROI",
    },
    summary: {
      revenue: "Revenue",
      orders: "Orders",
      occupancy: "Occupancy",
      customers: "Customers",
      newCount: "+{{count}} new",
    },
    revenue: {
      aov: "Average order value",
      perParticipant: "Revenue per participant",
      forecast: "Revenue forecast (confirmed orders)",
      forecastDetail: "Confirmed: {{confirmed}} | Deposit: {{deposit}}",
      overTime: "Revenue Over Time",
      thisYear: "This Year",
      lastYear: "Last Year",
      byDestination: "Revenue by Destination",
      tooltipRevenue: "Revenue",
    },
    ordersChart: {
      title: "Orders by status",
      tooltipOrders: "Orders",
    },
    funnel: {
      title: "Conversion Funnel",
      inquiryToQuoted: "Inquiry → Quoted",
      quotedToConfirmed: "Quoted → Confirmed",
      confirmedToPaid: "Confirmed → Paid",
      overallConversion: "Overall Conversion",
      cancellationRate: "Cancellation Rate",
    },
    trips: {
      topTrips: "Top 5 trips",
      bookings_one: "{{count}} booking",
      bookings_few: "{{count}} bookings",
      bookings_other: "{{count}} bookings",
      noTrips: "No trips",
      lowOccupancy: "Low occupancy (<30%)",
      allGoodOccupancy: "All dates have good occupancy",
      trendingDestinations: "Trending destinations (YoY)",
      notEnoughData: "Not enough data for comparison",
      avgGroupSize: "Average group size",
      participantsPerOrder: "participants per order",
    },
    guides: {
      datesByGuide: "Trip dates by guide",
      dates_one: "{{count}} date",
      dates_few: "{{count}} dates",
      dates_other: "{{count}} dates",
      unstaffed: "Dates without guide",
      allStaffed: "All dates have an assigned guide",
      overview: "Guide overview",
      guide: "Guide",
      dates: "Dates",
      rating: "Rating",
      revenue: "Revenue",
    },
    customers: {
      byCountry: "Customers by country",
      newVsReturning: "New vs returning",
      new: "New",
      returning: "Returning",
      newPct: "New {{pct}}%",
      returningPct: "Returning {{pct}}%",
      clv: "Average customer lifetime value (CLV)",
      topCustomers: "Top 10 customers",
      trips: "Trips",
      spent: "Spent",
      noCustomers: "No customers",
      countries: {
        cz: "Czech Republic",
        sk: "Slovakia",
        de: "Germany",
        at: "Austria",
        pl: "Poland",
        hu: "Hungary",
        gb: "United Kingdom",
        us: "USA",
      },
    },
    marketing: {
      newsletterSubscribers: "Newsletter subscribers",
      growthThisMonth: "+{{count}} this month",
      ordersBySource: "Orders by source",
      ordersCount_one: "{{count}} order",
      ordersCount_few: "{{count}} orders",
      ordersCount_other: "{{count}} orders",
      countLabel: "Count",
      revenueLabel: "Revenue",
      topUtm: "Top UTM campaigns",
      campaign: "Campaign",
      orders: "Orders",
      conversion: "Conversion",
      noUtm: "No UTM campaigns in this period",
      revenueBySource: "Revenue by source",
      source: "Source",
      avgValue: "Avg. value",
      sources: {
        webForm: "Web form",
        referral: "Referral",
        admin: "Admin",
        phone: "Phone",
        email: "Email",
        social: "Social media",
        other: "Other",
      },
    },
    traffic: {
      checkSettings: "Check Google Analytics settings in environment variables.",
      pageViews: "Page views",
      sessions: "Sessions",
      avgBounceRate: "Avg. bounce rate",
      avgSessionDuration: "Avg. session duration",
      overTime: "Traffic over time",
      topDestinations: "Top destinations",
      topTrips: "Top trips",
      trip: "Trip",
      views: "Views",
      bounce: "Bounce",
      avgDuration: "Avg. duration",
      bounceRate: "Bounce rate",
      detailedStats: "Detailed destination statistics",
    },
    ads: {
      checkSettings: "Check Google Ads settings in environment variables.",
      totalSpend: "Total Spend",
      adRevenue: "Ad Revenue",
      roas: "ROAS",
      conversions: "Conversions",
      avgCpa: "Avg. CPA",
      recommendations: "Recommendations",
      roasByDestination: "ROAS by Destination",
      roas5plus: "ROAS 5+",
      roas2to5: "ROAS 2-5",
      roas1to2: "ROAS 1-2",
      roasLoss: "ROAS <1 (loss)",
      spendVsRevenue: "Spend vs. Revenue Over Time",
      spend: "Spend",
      revenue: "Revenue",
      performanceByDestination: "Performance by Destination",
      cost: "Cost",
      cpa: "CPA",
      profitable: "Profitable",
      loss: "Loss",
      campaigns: "Campaigns",
      campaign: "Campaign",
      impressions: "Impressions",
      clicks: "Clicks",
      ctr: "CTR",
    },
  },
  audit: {
    subtitle:
      "Append-only trail of every status change, payment, document, cancellation, agent action and GDPR erasure.",
    allEntities: "All entities",
    entityTypes: {
      order: "Order",
      invoice: "Invoice",
      payment: "Payment",
      document: "Document",
      serviceBooking: "Service booking",
      departure: "Departure",
      complaint: "Complaint",
      agent: "Agent",
      customer: "Customer",
      guide: "Guide",
      trip: "Trip",
      lead: "Lead",
      destination: "Destination",
      activity: "Activity",
      settings: "Settings",
    },
    actionFilterPlaceholder: "Filter by action (e.g. payment, gdpr_forget)",
    revertedWithConflicts: "Reverted {{reverted}}, skipped {{skipped}} (changed since): {{labels}}",
    revertedFields_one: "Reverted {{count}} field.",
    revertedFields_few: "Reverted {{count}} fields.",
    revertedFields_other: "Reverted {{count}} fields.",
    alreadyReverted: "This edit was already reverted.",
    revertFailed: "Failed to revert",
    when: "When",
    entity: "Entity",
    action: "Action",
    actor: "Actor",
    summary: "Summary",
    noEntries: "No audit entries.",
    reverted: "Reverted",
    revert: "Revert",
  },
  users: {
    title: "User Management",
    subtitle: "Manage administration access",
    newUser: "New User",
    searchPlaceholder: "Search users...",
    loadError: "Error loading users",
    noUsers: "No users",
    user: "User",
    role: "Role",
    lastLogin: "Last Login",
    never: "Never",
    resetPassword: "Reset password",
    deactivate: "Deactivate",
    activate: "Activate",
    toasts: {
      statusChanged: "User status changed",
      statusChangeFailed: "Failed to change user status",
      deleted: "User deleted",
      deleteFailed: "Failed to delete user",
      created: "User created",
      createFailed: "Failed to create user",
      updated: "User updated",
      updateFailed: "Failed to update user",
      passwordReset: "Password has been reset",
      passwordResetFailed: "Failed to reset password",
      fillNameEmail: "Please fill in name and email",
      passwordMin: "Password must be at least 8 characters",
    },
    deleteTitle: "Delete user",
    deleteMessage: "Are you sure you want to delete user {{name}}? This cannot be undone.",
    form: {
      editTitle: "Edit User",
      createTitle: "New User",
      name: "Name",
      namePlaceholder: "John Smith",
      emailPlaceholder: "john@company.com",
      specialistQueue: "Specialist queue",
      queueHelp:
        "The service-booking kinds this person works (e.g. Flight for a flight specialist). The service queue lands them pre-filtered to these. Garants are routed by destination instead (set on the destination).",
      password: "Password",
      passwordKeepCurrent: "(leave empty to keep current)",
      passwordPlaceholder: "Min. 8 characters",
      accountActive: "Account is active",
    },
    roles: {
      adminLabel: "Administrator",
      adminDesc: "Full access to all features",
      editorLabel: "Content Editor",
      editorDesc: "Manage trips, destinations, guides, reviews and media",
      marketingLabel: "Marketing",
      marketingDesc: "Newsletter, segments, automated campaigns, customers",
      salesLabel: "Sales",
      salesDesc: "Orders, customers, inquiries",
      readonlyLabel: "Read Only",
      readonlyDesc: "View only without editing capabilities",
    },
    resetModal: {
      title: "Reset Password",
      intro: "Set a new password for user",
      newPassword: "New Password",
      submit: "Reset Password",
    },
  },
  integrations: {
    subtitle: "Connect external services",
    gdriveTitle: "Google Drive backups",
    gdriveSubtitle: "Weekly database + monthly storage backups.",
    oauthMisconfigured:
      "OAuth misconfigured: this API origin's redirect URI is not registered in the Google Cloud console.",
    oauthError: "Could not connect Google Drive. Please try again.",
    notConfigured:
      "Google OAuth client is not configured on the server (GDRIVE_CLIENT_ID / GDRIVE_CLIENT_SECRET secrets missing).",
    connected: "Connected",
    connectedAs: "Connected as {{email}}",
    backupFolder: "Backup folder",
    lastBackup: "Last backup",
    noBackupYet: "No backup yet",
    runBackupNow: "Run database backup now",
    backupStarted: "Backup started — refresh in a minute to see 'Last backup' update.",
    backupFailed: "Could not start the backup. Please try again.",
    disconnectConfirm: "Disconnect Google Drive? Scheduled backups will stop.",
    disconnect: "Disconnect",
    connect: "Connect Google Drive",
  },
};
